var React = require('react');

function Ne (props) {
    return React.createElement("svg",props,[React.createElement("path",{"fill":"#0db02b","d":"M0 0h640v480H0z","key":0}),React.createElement("path",{"fill":"#fff","d":"M0 0h640v320H0z","key":1}),React.createElement("path",{"fill":"#e05206","d":"M0 0h640v160H0z","key":2}),React.createElement("circle",{"cx":"320","cy":"240","r":"68","fill":"#e05206","key":3})]);
}

Ne.defaultProps = {"viewBox":"0 0 640 480"};

module.exports = Ne;

Ne.default = Ne;
